import { MAIN_STYLE, MAIN_STYLE_GROUPS, SELECTION_EVENTS } from '../shared.js'
export const roller = {
    displayName: 'Roller',
    parts: {
        main: {
            label: 'Main',
            exportSuffix: '',
            order: 0,
            propertyGroups: [...MAIN_STYLE_GROUPS],
            properties: {
                ...MAIN_STYLE,
                text_color: { type: 'color' },
                text_font:  { type: 'int', min: 8 },
                text_font_family: { type: 'string', internal: true },
            },
        },
        selected: {
            label: 'Selected',
            exportSuffix: '50',
            order: 1,
            properties: {
                bg_color: { type: 'color' },
                // Every theme file already sets text_color50 — this was
                // previously undeclared here, so HaspRoller.js read it via the
                // flat legacy proxy (this.text_color50) rather than
                // this.style('selected'); same class of gap as checkbox's
                // 'bullet' part (see checkbox.js).
                text_color: { type: 'color' },
                // LVGL genuinely supports (and firmware applies, via
                // lv_obj_init_draw_label_dsc(roller, LV_ROLLER_PART_SELECTED, ...))
                // a distinct font for the highlighted row vs. background rows
                // (lv_roller.c:444-446,484-485). Unlike dropdown, roller's
                // font-forcing helper does NOT unify fonts across parts, so this
                // is a real, independently-controllable property. See
                // FIRMWARE-PARITY-AUDIT.md's "roller" section.
                text_font: { type: 'int', min: 8 },
            },
        },
    },

    properties: {
        x: { type: 'int' }, y: { type: 'int' },
        width: { type: 'int', min: 0 }, height: { type: 'int', min: 0 },
        min_width: { type: 'int', min: 0 }, min_height: { type: 'int', min: 0 },
        haspid:   { type: 'int', min: 1, max: 254, internal: true },
        parentid: { type: 'int', min: 0, max: 254, internal: true },
        enabled: { type: 'bool' }, hidden: { type: 'bool' },
        val:     { type: 'int' },
        text:    { type: 'string', readOnly: true },
        options:      { type: 'string' },
        list_options: { type: 'bool', internal: true },
        rows:    { type: 'int', min: 1 },
        align:   { type: 'enum', values: ['left', 'center', 'right', 'auto'] },
        mode:    { type: 'int', min: 0, max: 1 },
        // Font Family selection for the row labels (main part) — see label.js's
        // `font` property comment for the full wire-format semantics. The
        // 'selected' part's own text_font is a real, independent LVGL slot
        // (see its property comment) but isn't rendered distinctly by
        // HaspRoller.js yet, so it has no font-resource slot of its own here.
        font: { type: 'resource', resourceType: 'font', label: 'Font Family', inline: true },
    },

    defaults: {
        properties: {
            x: 0, y: 0, width: 150, height: 100, min_width: 60, min_height: 10,
            enabled: true, hidden: false,
            rows: 3, align: 'center', mode: 0,
            options: 'Option1\nOption2\nOption3\nOption4\nOption5',
            font: '',
        },
    },
    states: ['pressed', 'disabled'],
    editorCapabilities:  ['can_transform', 'can_copy'],
    runtimeCapabilities: ['has_action'],

    events: SELECTION_EVENTS,

    convertTo: ['dropdown'],

    bindings: {
        properties: { val: {} },
        actions: { hass_services: ['', 'homeassistant', 'openhasp', 'input_select', 'esphome'] },
    },

    automation: {
        runtimeVariables: [
            { name: 'text', type: 'string', label: 'Selected Option', optionsFrom: 'options' },
            { name: 'val',  type: 'int',    label: 'Selected Option Index' },
        ],
        actionDomains: ['input_select', 'homeassistant', 'openhasp', 'esphome'],
    },
}
